<template>
  <div class="value-body-title">
    <h2>It is our mission to ensure mental, physical, and social wellness.</h2>
  </div>

  <div class="value-grid-container">

    <div class="top-container">
      <div>
        <img class="top-pics" src="../assets/ValueBodyTop.jpg">
      </div>

      <div class="top-text">
        <div class="top-text-title">
          <p>Who We Are</p>
        </div>

        <p>WMADCC is a healthcare facility that provides medical and recreational care in a community-based setting for individuals with varying limitations. We offer support for those requiring assistance with activities of daily living. Our services combat the social isolation that many older adults experience. Our goal is to promote both independence and a sense of community while maintaining optimal physical health in order to improve overall quality of life.</p>
        <p>Our experienced team consists of skilled nurses and social workers that are committed to providing a comfortable environment for your family. We believe in providing convenient, supervised care to foster health and wellness.</p> 
      </div>
    </div>

    <div class="bottom-container">
      <div class="bottom-text">
        <div class="bottom-text-title">
          <p>What We Do</p>
        </div>

        <p>Many families today are responsible for taking care of aging parents or family members with physical and/or cognitive limitations. For these caregivers, daily responsibilities can become overwhelming, making long-term care difficult to manage. As seniors continue to age, feelings of isolation and dissatisfaction tend to rise. WMADCC is designed to enrich quality of life for the elderly while allowing family members to fulfill personal responsibilities.</p>
        <p>At WMADCC, each client receives an individualized care plan that caters to his/her unique needs. Our seasoned nursing team provides daily health monitoring based directly on physician's orders. In addition to medical care, we also believe in the health benefits associated with socialization, and encourage clients to build connections and relationships. We guarantee a positive, multi-faceted approach to enrich our clients' lifestyles and prevent loneliness. </p>
      </div>

      <div>
        <img class="bottom-pics" src="../assets/ValueBodyBottom.jpg">
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: 'ValueBody'
  }

  </script>
  
  <style scoped>
   
/* for desktop */
@media (min-width:701px) {

  .value-body-title {
    text-align: center;
    color: darkblue;
  }

  .value-grid-container {
    display: grid;
    grid-template-rows: 1fr 1fr;
  }

  .top-container {
    place-items: center;
    display: grid;
    grid-template-columns: 1fr 2.5fr;
    border: 1px solid gray;
    background-color: rgb(238, 238, 238);
  }

  .top-pics {
    width: 18vw;
    height: 18vw;
    border: 5px solid #fff;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.5);
    margin-left: 1vw;
  }

  .top-text-title {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 1vw;
  }

  .top-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: lighter;
    line-height: 2.5vw;
    justify-content: top left;
    margin-top: -1vw;
    margin-right: 3vw;
  }

  .bottom-container {
    place-items: center;
    display: grid;
    grid-template-columns: 2.5fr 1fr;
    border: 1px solid gray;
    background-color: rgb(238, 238, 238);
  }

  .bottom-pics {
    width: 18vw;
    height: 18vw;
    border: 5px solid #fff;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.5);
    margin-left: 2vw;
    margin-right: 2vw;
  }

  .bottom-text-title {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 3vw;
    margin-bottom: 2vw;
  }

  .bottom-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: lighter;
    line-height: 2.5vw;
    margin-left: 4.5vw;
  }
}

/* for Phone */
@media (max-width:700px) {
  .value-body-title {
    text-align: center;
    font-size: 3vw;
    color: darkblue;
  }

  .top-pics, .bottom-pics {
    width: 15rem;
    height: 10rem;
  }

  .top-text-title, .bottom-text-title {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 3.5vw;
    font-weight: bold;
    height: auto;
    justify-content: top left;
  }

  .top-text, .bottom-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 3.5vw;
    height: auto;
    justify-content: top left;
  }

}

</style>